export default "__VITE_ASSET__D2IgwahO__"